/**
 * Services Configuration
 *
 * Dependency injection configuration for services.
 * All domain traffic goes through the Storefront BFF.
 */

import { IProductService } from '@/domain/services/product.service.interface';
import { ICartService } from '@/domain/services/cart.service.interface';
import { IReviewService } from '@/domain/services/review.service.interface';
import { IOrderService } from '@/domain/services/order.service.interface';
import { ProductBffService } from '../services/bff/product.bff-service';
import { CartBffService } from '../services/bff/cart.bff-service';
import { ReviewBffService } from '../services/bff/review.bff-service';
import { OrderService } from '../services/order.service';
import { IPackService, PackServiceImplementation } from '../services/pack.service';
import { env } from '@/lib/utils/env';

// Service instances
export const productService: IProductService = new ProductBffService();
export const cartService: ICartService = new CartBffService();
export const reviewService: IReviewService = new ReviewBffService();
export const orderService: IOrderService = new OrderService();
export const packService: IPackService = new PackServiceImplementation();

export interface ServicesConfig {
  checkoutUrl: string;
}

export function getServicesConfig(): ServicesConfig {
  return {
    checkoutUrl: env.CHECKOUT_URL,
  };
}
